import { IDropdownOption } from '~/common/components/Dropdown/types';

import fetch from '../../fetch';
import { IHttpMethod } from '../../../ts/enums/fetch-enums';

const controllerName = 'users';

const endpoints = {
  options: `${controllerName}/options`,
  configurations: (id: string) => `${controllerName}/${id}/configurations`,
};

export interface IUserConfigurations {
  defaultProposalRequester?: string;
  /** Última versão de release notes já exibida para o usuário (semver). */
  ultimaVersaoNotasVista?: string;
}

export async function getUsers() {
  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: controllerName,
  });

  return data;
}

export enum UserProfilesOptions {
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
  RH = 'rh',
  TST = 'tst',
  COORDINATOR = 'coordinator',
}
export async function getUsersOptions(
  profilesArray: UserProfilesOptions[]
): Promise<IDropdownOption[]> {
  const profiles = profilesArray
    .map((profile) => (profile as unknown as string).trim().toLowerCase())
    .join(',');

  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: `${endpoints.options}?profiles=${profiles}`,
  });

  return data;
}

export async function getUserById(id: string) {
  const { data } = await fetch({
    method: IHttpMethod.GET,
    path: `${controllerName}/${id}`,
  });

  return data;
}

interface ICreateUserParams {
  name: string;
  login: string;
  password: string;
  profileId: string;
}

export async function createUser(data: ICreateUserParams) {
  return fetch({
    method: IHttpMethod.POST,
    path: controllerName,
    data,
  });
}

interface IUpdateUserParams {
  name: string;
  profileId: string;
  password?: string;
}

export async function updateUser(data: IUpdateUserParams, id: string) {
  return fetch({
    method: IHttpMethod.PUT,
    path: `${controllerName}/${id}`,
    data,
  });
}

export async function updateUserConfigurations(
  data: { configuracoes?: IUserConfigurations },
  id: string
) {
  return fetch({
    method: IHttpMethod.PATCH,
    path: endpoints.configurations(id),
    data,
  });
}

export async function deleteUserById(id: string) {
  return fetch({
    method: IHttpMethod.DELETE,
    path: `${controllerName}/${id}`,
  });
}
